import { render, staticRenderFns } from "./addressChoose.vue?vue&type=template&id=1242394c&scoped=true"
import script from "./addressChoose.vue?vue&type=script&lang=js"
export * from "./addressChoose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1242394c",
  null
  
)

export default component.exports